import { render, staticRenderFns } from "./PricelistList.vue?vue&type=template&id=fcf09602&"
import script from "./PricelistList.vue?vue&type=script&lang=ts&"
export * from "./PricelistList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports